import { useCallback } from "react";
import type { PaywallPrice } from "@/react/types/Paywall";
import { usePaywallCheckoutContext } from "@circle-react/contexts/Paywalls/paywallCheckoutContext";
import { PaywallPriceOption } from "./PaywallPriceOption";

export const PaywallPricesWithPMC = () => {
  const { paywall, setSelectedPrice, isSelectedPrice } =
    usePaywallCheckoutContext();

  const onPriceChangeHandler = useCallback(
    (priceId: number) => {
      setSelectedPrice(priceId);
    },
    [setSelectedPrice],
  );

  return (
    <>
      {paywall.prices.map((price: PaywallPrice) => (
        <PaywallPriceOption
          key={`paywall_price-${price.id}`}
          id={price.id}
          title={price.title}
          subtitle={price.subtitle}
          value={price.value}
          isSelected={isSelectedPrice(price)}
          onSelect={onPriceChangeHandler}
        />
      ))}
    </>
  );
};
